import Vue from "vue";

function initialLoad() {
  return {
    ruleModalInfo: {
      showModal: false,
      ruleName: "",
      triggerSetId: 0
    },
    internetTabActionInProgress: false
  };
}

const state = initialLoad();

const actions = {
  fetchInternetAssignments: function(context, platform) {
    context.commit("updateSpinnerForInternetTab", true);
    return new Promise((resolve, reject) => {
      Vue.http
        .get(
          "/pando/pandox/leadassignment/grouped?accountPlatformId=" + platform
        )
        .then(data => {
          if (data && data.data) resolve(data.data.Data ? data.data.Data : []);
          context.commit("updateSpinnerForInternetTab", false);
        })
        .catch(err => {
          reject(err);
          context.commit("updateSpinnerForInternetTab", false);
        });
    });
  },
  fetchRuleDetails: function(context, triggerSetId) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "get",
        "/api/TriggerSet/" + triggerSetId
      )
        .then(response => {
          if (response && response.data && response.data.data)
            resolve(response.data.data);
          else reject(response);
        })
        .catch(error => reject(error));
    });
  },
  loadVehicleFilterValues: function(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "put",
        "/api/TriggerSet/filterValues/vehicle",
        request
      )
        .then(response => {
          if (response && response.data && response.data.data)
            resolve(response.data.data);
          else reject(response);
        })
        .catch(error => reject(error));
    });
  },
  saveRuleDetail: function(context, ruleDetails) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/TriggerSet",
        ruleDetails
      )
        .then(response => {
          if (response && response.data && response.data.data)
            resolve(response.data.data);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveRuleRank: function(context, ruleRankDetail) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "put",
        "/api/TriggerSet/" + ruleRankDetail.id + "/set_rank",
        ruleRankDetail.payload
      )
        .then(response => {
          if (response && response.data && response.data.data)
            resolve(response.data.data);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAssignmentHistory: function(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/TriggerSet/assignment_history",
        request
      )
        .then(response => {
          if (response && response.data)
            resolve(response.data);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchNextUp: function(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/TriggerSet/next_up",
        request
      )
        .then(response => {
          if (response && response.data)
            resolve(response.data);
          else reject(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  archiveRule: function(context, payload) {
    return new Promise((resolve, reject) => {
      Vue.http
        .post("/pando/pandox/triggers/deactivate", payload)
        .then(response => {
          if (response && response.data && response.data.Success)
            resolve(response.data.Success);
          else reject(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateArchiveRuleModal: function(context, info) {
    context.commit("updateArchiveRuleModal", info);
  }
};

const mutations = {
  updateArchiveRuleModal: function(state, info) {
    state.ruleModalInfo = info;
  },
  updateSpinnerForInternetTab: function(state, loading) {
    state.internetTabActionInProgress = loading;
  }
};

const getters = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/InternetLeadManagement.js